import React from 'react';
import { CheckIcon, TruckIcon, ShieldIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-background py-12 sm:py-20" data-id="element-246">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        {/* Trust bar above headline */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-8 text-sm text-muted-foreground" data-id="element-248">
          <div className="flex items-center gap-1.5" data-id="element-249">
            <div className="flex" data-id="element-250">
              <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-251" />
              <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-252" />
              <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-253" />
              <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-254" />
              <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-255" />
            </div>
            <span className="font-semibold text-foreground" data-id="element-256">4.8/5</span>
          </div>
          <span className="hidden sm:inline text-border" data-id="element-257">·</span>
          <span data-id="element-258">+10.000 clientas satisfechas</span>
          <span className="hidden sm:inline text-border" data-id="element-259">·</span>
          <div className="flex items-center gap-1" data-id="element-260">
            <ShieldIcon className="w-3.5 h-3.5 text-green-600" data-id="element-261" />
            <span data-id="element-262">Garantía 90 días</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-263">
          {/* Left: Content */}
          <div className="flex flex-col gap-6" data-id="element-264">
            {/* Red urgency badge */}
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 text-sm font-bold px-3 py-1.5 rounded-full w-fit border border-red-200" data-id="element-265">
              🔥 ÚLTIMAS UNIDADES — OFERTA TERMINA HOY
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight" data-id="element-266">
              Recupera el Control de tu Metabolismo{' '}
              <span className="text-green-600" data-id="element-267">Después de los 35</span>
            </h1>

            <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-268">
              7 ampollas bebibles de solución oral GLP-1+NAD+ — un ciclo de 21
              días para apoyar la saciedad, reducir los antojos y volver a
              sentirte ligera sin dietas extremas.
            </p>

            {/* Product format strip */}
            <div className="flex flex-wrap items-center gap-3" data-id="element-269">
              <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-lg px-3 py-2" data-id="element-270">
                <span className="text-lg" data-id="element-271">💧</span>
                <div data-id="element-272">
                  <p className="text-xs font-bold text-green-800" data-id="element-273">7 Ampollas</p>
                  <p className="text-xs text-green-700" data-id="element-274">por caja</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-lg px-3 py-2" data-id="element-275">
                <span className="text-lg" data-id="element-276">📅</span>
                <div data-id="element-277">
                  <p className="text-xs font-bold text-green-800" data-id="element-278">21 Días</p>
                  <p className="text-xs text-green-700" data-id="element-279">por ciclo</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-lg px-3 py-2" data-id="element-280">
                <span className="text-lg" data-id="element-281">✅</span>
                <div data-id="element-282">
                  <p className="text-xs font-bold text-green-800" data-id="element-283">Fácil uso</p>
                  <p className="text-xs text-green-700" data-id="element-284">beber directo</p>
                </div>
              </div>
            </div>

            {/* Bullet points */}
            <ul className="flex flex-col gap-3" data-id="element-285">
              <li className="flex items-center gap-3" data-id="element-286">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-287" />
                <span className="text-foreground" data-id="element-288">
                  Vientre visiblemente más plano en solo 5 días
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-289">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-290" />
                <span className="text-foreground" data-id="element-291">
                  Ayuda a reducir el hambre, los antojos y el picoteo emocional
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-292">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-293" />
                <span className="text-foreground" data-id="element-294">
                  Quema grasa — incluso mientras duermes
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-295">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-296" />
                <span className="text-foreground" data-id="element-297">
                  Apoyo clínicamente probado para la vía GLP-1
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-298">
                <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-299" />
                <span className="text-foreground" data-id="element-300">
                  Aprobado por médicos y recomendado por miles de personas
                </span>
              </li>
            </ul>

            {/* CTA Button */}
            <div className="flex flex-col gap-3 mt-2" data-id="element-301">
              <a href="#pricing" className="w-full text-center bg-green-600 hover:bg-green-700 text-white font-bold text-lg px-8 py-4 rounded-xl transition-colors duration-200 tracking-wide shadow-md hover:shadow-lg" data-id="element-302">
                SÍ, QUIERO PROBAR TRIMORA →
              </a>

              {/* Trust icons below CTA */}
              <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm text-muted-foreground" data-id="element-303">
                <span data-id="element-304">✅ Envío Gratis Hoy</span>
                <span data-id="element-305">·</span>
                <span data-id="element-306">✅ Garantía 90 Días</span>
                <span data-id="element-307">·</span>
                <span data-id="element-308">✅ Pago 100% Seguro</span>
              </div>
            </div>
          </div>

          {/* Right: Product GIF with floating overlays */}
          <div className="flex justify-center lg:justify-end" data-id="element-309">
            <div className="relative w-full max-w-md" data-id="element-310">
              <div className="aspect-square rounded-2xl overflow-hidden border border-green-100 shadow-md" data-id="element-311">
                <img src="https://cdn.magicpatterns.com/uploads/4s7Nvjd95E2bty1qyAk2mp/imgi_4_1765695310-imgi_3_1760553797-227_-_Funnel_Image.gif" alt="Trimora GLP-1+NAD+ resultado" className="w-full h-full object-cover" unselectable="on" data-id="element-312" />
              </div>

              {/* Top-right: result badge */}
              <div className="absolute top-3 right-3 bg-green-800 text-white text-xs font-bold px-3 py-1.5 rounded-lg shadow-lg" data-id="element-313">
                -5 kg media en 21 días
              </div>

              {/* Bottom-left: floating verified review card */}
              <div className="absolute bottom-3 left-3 bg-white shadow-xl rounded-xl p-3 max-w-[200px] border border-border" data-id="element-314">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-315">
                  <span className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0" data-id="element-316"></span>
                  <span className="text-xs font-bold text-green-700 uppercase tracking-wide" data-id="element-317">
                    Verificado
                  </span>
                </div>
                <div className="flex gap-0.5 mb-1.5" data-id="element-318">
                  <StarIcon className="w-3 h-3 text-green-400 fill-green-400" data-id="element-319" />
                  <StarIcon className="w-3 h-3 text-green-400 fill-green-400" data-id="element-320" />
                  <StarIcon className="w-3 h-3 text-green-400 fill-green-400" data-id="element-321" />
                  <StarIcon className="w-3 h-3 text-green-400 fill-green-400" data-id="element-322" />
                  <StarIcon className="w-3 h-3 text-green-400 fill-green-400" data-id="element-323" />
                </div>
                <p className="text-xs text-foreground leading-snug font-medium" data-id="element-324">
                  "Perdí 6 kg y 8 cm de cintura en 3 semanas."
                </p>
                <p className="text-xs text-muted-foreground mt-1" data-id="element-325">
                  — Carmen M., 42 años
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}